import React, { createContext, useContext, ReactNode } from 'react';
import { Stripe } from '@stripe/stripe-js';
import { stripePromise } from '../core/initialize';

interface StripeContextValue {
  stripe: Promise<Stripe | null>;
}

const StripeContext = createContext<StripeContextValue | undefined>(undefined);

export function StripeProvider({ children }: { children: ReactNode }) {
  return (
    <StripeContext.Provider value={{ stripe: stripePromise }}>
      {children}
    </StripeContext.Provider>
  );
}

export function useStripe() {
  const context = useContext(StripeContext);
  if (context === undefined) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
}